module.exports = __webpack_public_path__ + "assets/img/LTC047.85ba3d28.jpg";